'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import React, { useState } from 'react';
import { useParams } from 'next/navigation';
import Link from 'next/link';
import Image from 'next/image';
import {
  Container,
  Col,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  Fade,
} from 'reactstrap';
import Cta from 'shared/components/CtaBtn';
import TestimonialTile from 'shared/components/TestimonialTile';
import useScrollHeight from '../hooks/useScrollHeight';

const app = process.env.NEXT_PUBLIC_APP;

function AboutFr({ testimonial }: { testimonial: boolean }) {
  const { locale } = useParams();
  const scrollHeight = useScrollHeight();
  const [activeTab, setActiveTab] = useState('1');
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <>
      <Container>
        <Row className="position-relative">
          <Col lg={{ offset: 3, size: 9 }} className="d-lg-flex justify-content-lg-end">
            <div id="main-cta" className={scrollHeight > 500 ? 'fixed' : ''}>
              <Link href={app === 'werkenbijsynergie.be' ? '/jobs' : `/${locale}/jobs`}>
                <Button color="yellow" className="px-4 text-dark pt-2 pb-2">
                  L'emploi de vos rêves en un clic
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
      <section className="pt-5 pb-4 pb-lg-5">
        <Container className="mt-lg-4 mb-4">
          <Row>
            <Col lg={6} className="px-lg-5">
              <p>
                Permettez-nous de nous présenter : <strong>Synergie Belgium</strong>, ce sont 500 collègues, plus de 70 agences et
                Inhouses. Quatre divisions spécialisées : Interim, Careers, Construct et S&you. Chacune se concentre sur un
                objectif : <strong>placer la bonne personne au bon endroit</strong>. Que faisons-nous exactement ? Nous vous
                aidons à vous développer, que vous soyez travailleur ou employeur. Ensemble, nous faisons de votre travail un
                succès depuis plus de 25 ans en Belgique.
              </p>
              <p>Vous pensez spontanément à l’intérim ? C'est exact mais cela ne s'arrête pas là !</p>
            </Col>
            <Col lg={6} className="px-lg-5">
              <p>
                Nous fournissons du personnel supplémentaire pendant les pics d'activité mais aussi des employés sous contrat fixe
                et des professionnels compétents pour des projets ponctuels. Dans notre recherche, nous allons toujours au-delà du
                CV.
              </p>
              <p>
                Vous aussi, vous pouvez voir plus loin, au-delà des frontières. Grâce à Synergie Belgium, vous avez accès à un
                réseau international : avec ses 750 sites Synergie dans 17 pays,{' '}
                <a href="https://www.synergie.com" target="__blank" rel="noopener noreferrer">
                  le groupe RH Synergie
                </a>{' '}
                compte 4 400 collaborateurs et 95 000 entreprises clientes. Synergie se classe à la{' '}
                <strong>5ᵉ place en Europe</strong> et à la <strong>1ère place du marché français</strong> sur le marché de
                l’intérim.{' '}
              </p>
              {app !== 'werkenbijsynergie.be' && (
                <Link className="align-self-end" href={`/${locale}/employers/contact`}>
                  <Cta className="cta border-solid btn-outline-primary" type="button">
                    Contactez-nous
                  </Cta>
                </Link>
              )}
            </Col>
          </Row>
        </Container>
      </section>
      <section className="pt-lg-5 pb-lg-5 pt-4 pb-4 bg-light">
        <Container className="mt-4 mb-4">
          <h2 className="text-uppercase">Comment vous offrir le service dont vous avez besoin ?</h2>

          <p className="pt-3 pb-3">
            Comme nous l'avons déjà mentionné, Synergie, c’est quatre divisons spécialisées qui ont chacune leur domaine
            d’activité. Vous obtenez de cette façon exactement le service dont vous avez besoin, même la synergie entre les
            divisions car l'union fait la force !
          </p>

          <Nav tabs className="d-flex">
            <NavItem className="flex-grow-1">
              <NavLink
                className={`d-flex justify-content-center align-items-center p-3${activeTab === '1' ? ' active' : ''}`}
                onClick={() => {
                  toggle('1');
                }}
              >
                <Image
                  className="d-inline-block me-0 me-lg-3"
                  src="/icons/about/interim.svg"
                  alt="Interim Icon"
                  height={30}
                  width={30}
                />
                <span className="d-none d-lg-inline-block">Synergie Jobs</span>
              </NavLink>
            </NavItem>
            <NavItem className="flex-grow-1">
              <NavLink
                className={`d-flex justify-content-center align-items-center p-3${activeTab === '2' ? ' active' : ''}`}
                onClick={() => {
                  toggle('2');
                }}
              >
                <Image
                  className="d-inline-block me-0 me-lg-3"
                  src="/icons/about/construct.svg"
                  alt="Construct Icon"
                  height={30}
                  width={30}
                />
                <span className="d-none d-lg-inline-block">Synergie Construct</span>
              </NavLink>
            </NavItem>
            <NavItem className="flex-grow-1">
              <NavLink
                className={`d-flex justify-content-center align-items-center p-3${activeTab === '3' ? ' active' : ''}`}
                onClick={() => {
                  toggle('3');
                }}
              >
                <Image
                  className="d-inline-block me-0 me-lg-3"
                  src="/icons/about/careers.svg"
                  alt="Careers Icon"
                  height={30}
                  width={30}
                />
                <span className="d-none d-lg-inline-block">Synergie Careers</span>
              </NavLink>
            </NavItem>
            <NavItem className="flex-grow-1">
              <NavLink
                className={`d-flex justify-content-center align-items-center p-3${activeTab === '4' ? ' active' : ''}`}
                onClick={() => {
                  toggle('4');
                }}
              >
                <Image
                  className="d-inline-block me-0 me-lg-3"
                  src="/icons/about/sandyou.svg"
                  alt="Division Sandyou Icon"
                  height={30}
                  width={30}
                />
                <span className="d-none d-lg-inline-block">S&you</span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab} className="border border-secondary border-top-0">
            <TabPane tabId="1">
              <Card body className="p-5">
                <Fade in={activeTab === '1'} timeout={200}>
                  <CardTitle tag="h3" className="text-uppercase">
                    Synergie Jobs
                  </CardTitle>
                  <CardText>
                    Nos consultants travaillent en étroite collaboration avec des PME ainsi qu'avec de grandes entreprises, et
                    matchent les talents aux entreprises pour des missions intérimaires, des emplois temporaires avec perspective
                    de contrat fixe, ainsi que des recrutements en CDI. Nous recrutons des profils dans divers domaines
                    professionnels tels que la logistique, la production, la technique, la vente & le retail, le nettoyage et
                    l’horeca.
                  </CardText>
                  <a href="https://www.synergiejobs.be/" target="_blank" rel="noopener noreferrer">
                    <Cta className="cta red" type="button">
                      Consultez le site
                    </Cta>
                  </a>
                </Fade>
              </Card>
            </TabPane>
            <TabPane tabId="2">
              <Card body className="p-5">
                <Fade in={activeTab === '2'} timeout={200}>
                  <CardTitle tag="h3" className="text-uppercase">
                    Synergie Construct
                  </CardTitle>
                  <CardText>
                    Nous nous adressons ici aux ouvriers de tous les domaines du secteur de la construction. La bonne personne
                    (h/f) sur le bon chantier, voilà notre défi. Domaine clé : la sécurité. Nos consultants ont tous un certificat
                    VCU et nos intérimaires une attestation VCA.
                  </CardText>
                  <a href="https://www.synergieconstruct.be/" target="_blank" rel="noopener noreferrer">
                    <Cta className="cta red" type="button">
                      Consultez le site
                    </Cta>
                  </a>
                </Fade>
              </Card>
            </TabPane>
            <TabPane tabId="3">
              <Card body className="p-5">
                <Fade in={activeTab === '3'} timeout={200}>
                  <CardTitle tag="h3" className="text-uppercase">
                    Synergie Careers
                  </CardTitle>
                  <CardText>
                    Ce sont <strong>les employés</strong> qui sont au cœur de cette division, pour une mission intérimaire ou pour
                    un emploi fixe. Nos consultants recherchent <strong>la meilleure adéquation possible</strong> entre les
                    candidats et les entreprises en gardant toujours de vue une relation à long terme.
                  </CardText>
                  <a href="https://www.synergiecareers.be/" target="_blank" rel="noopener noreferrer">
                    <Cta className="cta red" type="button">
                      Consultez le site
                    </Cta>
                  </a>
                </Fade>
              </Card>
            </TabPane>
            <TabPane tabId="4">
              <Card body className="p-5">
                <Fade in={activeTab === '4'} timeout={200}>
                  <CardTitle tag="h3" className="text-uppercase">
                    S&you
                  </CardTitle>
                  <CardText>
                    Il s'agit de la division des experts RH dans le recrutement et{' '}
                    <strong>la sélection d'employés et de cadres spécialisés</strong>. Nos HR Business Partners examinent à la
                    loupe toutes les offres d'emploi et proposent une réponse 100 % personnalisée.
                  </CardText>
                  <a href="https://www.sandyou.be/" target="_blank" rel="noopener noreferrer">
                    <Cta className="cta red" type="button">
                      Consultez le site
                    </Cta>
                  </a>
                </Fade>
              </Card>
            </TabPane>
          </TabContent>
        </Container>
      </section>
      <section className="pt-lg-5 pb-lg-5 pt-4 pb-4">
        <Container className="mt-4 mb-4">
          <TestimonialTile
            quote="Synergie est une équipe soudée avec une mission commune : créer des solutions durables pour nos candidats et nos clients dans un marché du travail en constante évolution."
            name="TOM VANOIRBEEK"
            imagePath="/images/tom_vanoirbeek.jpg"
            position="CEO SYNERGIE BELGIUM"
            quoteColor="var(--bs-warning)"
          />
        </Container>
      </section>
      <section className="pt-lg-5 pb-lg-5 pt-4 pb-4 bg-light">
        <Container className="mt-4 mb-4">
          <Row>
            <Col lg={{ size: 6, order: 2 }} className="d-flex justify-content-center align-items-center">
              <svg
                className="bigIcon p-3 mb-3 mb-lg-0"
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="200"
                viewBox="0 0 38.08 34.5"
              >
                <g id="Group_8" data-name="Group 8" transform="translate(-693.136 -355.087)">
                  <line
                    id="Line_22"
                    data-name="Line 22"
                    y2="15.2"
                    transform="translate(712.176 374.127)"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <line
                    id="Line_23"
                    data-name="Line 23"
                    x1="8.8"
                    transform="translate(712.176 374.127)"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <line
                    id="Line_24"
                    data-name="Line 24"
                    x2="8.8"
                    transform="translate(703.376 374.127)"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M727.382,369.336l-4.806,2.391h-4.8a2.4,2.4,0,0,1-2.4-2.4l5.6-.8s3.7-3.2,4.8-3.2l2.4,0a2.407,2.407,0,0,1,2.4,2.4v10.4a4.012,4.012,0,0,1-4,4h-4.8l-3.2,7.2"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_37"
                    data-name="Path 37"
                    d="M724.976,362.931a3.229,3.229,0,0,0,3.2-3.2v-.8a3.2,3.2,0,1,0-6.4,0v.8A3.229,3.229,0,0,0,724.976,362.931Z"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_38"
                    data-name="Path 38"
                    d="M724.976,370.927v6.4h-4.184a3.449,3.449,0,0,0-3.016,2.4l-3.177,9.6"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_39"
                    data-name="Path 39"
                    d="M696.97,369.336l4.806,2.391h4.8a2.4,2.4,0,0,0,2.4-2.4l-5.6-.8s-3.7-3.2-4.8-3.2l-2.4,0a2.407,2.407,0,0,0-2.4,2.4v10.4a4.012,4.012,0,0,0,4,4h4.8l3.2,7.2"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M699.376,362.931a3.229,3.229,0,0,1-3.2-3.2v-.8a3.2,3.2,0,1,1,6.4,0v.8A3.229,3.229,0,0,1,699.376,362.931Z"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_41"
                    data-name="Path 41"
                    d="M699.376,370.927v6.4h4.184a3.449,3.449,0,0,1,3.016,2.4l3.177,9.6"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                </g>
              </svg>
            </Col>
            <Col lg={{ size: 6, order: 1 }}>
              <h2 className="text-uppercase">Qu'est-ce que la synergie ?</h2>
              <p className="pt-3 pb-3">
                Une chose est sûre : la synergie fonctionne ! C'est ce que prouvent les chiffres. Depuis 2010, nous avons doublé
                notre chiffre d'affaires ! Pourquoi Synergie vous séduit- il ? Quelle est la clé de ce succès ? C'est la culture
                particulière de Synergie qui se résume en trois mots-clés :{' '}
                <strong>pragmatisme, approche personnelle et collaboration durable</strong>.
              </p>
              <div>
                {app === 'werkenbijsynergie.be' ? (
                  <a href="https://www.synergiejobs.be/fr/synergie-values" target="_blank" rel="noopener noreferrer">
                    <Cta className="cta red" type="button">
                      Découvrez nos 5 valeurs fondamentales
                    </Cta>
                  </a>
                ) : (
                  <Link href={`/${locale}/synergie-values`}>
                    <Cta className="cta red" type="button">
                      Découvrez nos 5 valeurs fondamentales
                    </Cta>
                  </Link>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pt-lg-5 pb-lg-5 pt-4 pb-4">
        <Container className="mt-4 mb-4">
          <p className="text-center mt-3 mb-3 w-75 mx-auto">
            Vous ne tarderez pas à le remarquer : en tant que <strong>challenger sur le marché</strong>, nous sommes des
            entrepreneurs. Nous n'avons donc pas peur de prendre des initiatives, de saisir les occasions qui se présentent et de
            créer des opportunités.
          </p>
          <h2 className="p-4 text-uppercase text-center">A quoi nous reconnaît-on ?</h2>
          <Row>
            <Col sm="6">
              <div className="px-3 pt-1 pb-1 ms-lg-5 me-lg-5 mt-3 mb-3">
                <Image
                  className="d-block mx-auto p-2 mt-2 mb-2"
                  src="/icons/about/communicate.svg"
                  alt="icon"
                  width={96}
                  height={96}
                />

                <p className="border-primary border-top pt-2 text-center">
                  Nous aimons travailler ensemble en maintenant une communication ouverte.
                </p>
              </div>
            </Col>
            <Col sm="6">
              <div className="px-3 pt-1 pb-1 ms-lg-5 me-lg-5 mt-3 mb-3">
                <Image
                  className="d-block mx-auto p-2 mt-2 mb-2"
                  src="/icons/about/support.svg"
                  alt="icon"
                  width={96}
                  height={96}
                />

                <p className="border-primary border-top pt-2 text-center">
                  Nous nous soutenons au maximum mutuellement et nous renforçons notre résilience.
                </p>
              </div>
            </Col>
            <Col sm="6">
              <div className="px-3 pt-1 pb-1 ms-lg-5 me-lg-5 mt-3 mb-3">
                <Image
                  className="d-block mx-auto p-2 mt-2 mb-2"
                  src="/icons/about/dynamic.svg"
                  alt="icon"
                  width={96}
                  height={96}
                />

                <p className="border-primary border-top pt-2 text-center">
                  Nous apprenons constamment de nos expériences, nous osons nous remettre en question, nous attachons une grande
                  importance aux retours d'informations, nous pensons en terme de solutions et nous nous efforçons de toujours
                  faire mieux
                </p>
              </div>
            </Col>
            <Col sm="6">
              <div className="px-3 pt-1 pb-1 ms-lg-5 me-lg-5 mt-3 mb-3">
                <Image
                  className="d-block mx-auto p-2 mt-2 mb-2"
                  src="/icons/about/handson.svg"
                  alt="icon"
                  width={96}
                  height={96}
                />

                <p className="border-primary border-top pt-2 text-center">
                  Notre approche est accessible, pratique et constructive.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="d-flex justify-content-center">
          {app === 'werkenbijsynergie.be' ? (
            <a
              href={`https://www.synergiejobs.be/${locale}/agencies`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Prenez rendez-vous et découvrez tout cela par vous-même
            </a>
          ) : (
            <Link href={`/${locale}/agencies`}>
              <Cta className="cta red" type="button">
                Prenez rendez-vous et découvrez tout cela par vous-même
              </Cta>
            </Link>
          )}
        </div>
      </section>
      <section className="pt-lg-5 pb-lg-5 pt-4 pb-4">
        <Container className="mt-4 mb-4">
          <TestimonialTile
            quote="Nous pensons qu'il est important que nos collègues se sentent bien chez Synergie
            et surtout qu'ils puissent être eux-mêmes."
            name="VERONIQUE VAN DE PEER"
            imagePath="/images/veronique_van_de_peer.jpg"
            position="DIRECTRICE RH CHEZ SYNERGIE"
            quoteColor="var(--bs-warning)"
          />
        </Container>
      </section>
      {app !== 'werkenbijsynergie.be' && (
        <section className="pt-lg-5 pb-lg-5 pt-4 pb-4 bg-light">
          <Container className="mt-4 mb-4 ">
            <Row>
              <Col lg="6" className="d-flex  align-items-center">
                <svg
                  className="bigIcon d-block mx-auto p-3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="200"
                  height="200"
                  viewBox="0 0 38.08 37.44"
                >
                  <g id="Group_9" data-name="Group 9" transform="translate(-692.276 -443.123)">
                    <path
                      id="Path_42"
                      data-name="Path 42"
                      d="M726.516,470.963v4h-4"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_25"
                      data-name="Line 25"
                      x2="5.6"
                      y2="5.6"
                      transform="translate(720.916 469.363)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_43"
                      data-name="Path 43"
                      d="M726.516,453.363v-4h-4"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_26"
                      data-name="Line 26"
                      y1="5.6"
                      x2="5.6"
                      transform="translate(720.916 449.363)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_44"
                      data-name="Path 44"
                      d="M726.516,465.363l3.2-3.2-3.2-3.2"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_27"
                      data-name="Line 27"
                      x1="8"
                      transform="translate(721.716 462.163)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_45"
                      data-name="Path 45"
                      d="M696.116,470.963v4h4"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_28"
                      data-name="Line 28"
                      x1="5.6"
                      y2="5.6"
                      transform="translate(696.116 469.363)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_46"
                      data-name="Path 46"
                      d="M696.116,453.363v-4h4"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_29"
                      data-name="Line 29"
                      x1="5.6"
                      y1="5.6"
                      transform="translate(696.116 449.363)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_47"
                      data-name="Path 47"
                      d="M696.116,465.363l-3.2-3.2,3.2-3.2"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_30"
                      data-name="Line 30"
                      x2="8"
                      transform="translate(692.916 462.163)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_31"
                      data-name="Line 31"
                      y2="12.8"
                      transform="translate(711.316 467.763)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_32"
                      data-name="Line 32"
                      y2="20.8"
                      transform="translate(707.316 459.763)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_33"
                      data-name="Line 33"
                      y1="20.8"
                      transform="translate(715.316 459.763)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_48"
                      data-name="Path 48"
                      d="M711.316,451.763a3.067,3.067,0,0,0,3.2-3.2v-1.6a3.2,3.2,0,1,0-6.4,0v1.6A3.067,3.067,0,0,0,711.316,451.763Z"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_49"
                      data-name="Path 49"
                      d="M715.316,468.563a3.374,3.374,0,0,0,3.2-3.2v-7.2c0-2.643-4.421-4-7.2-4s-7.2,1.357-7.2,4v7.2a3.373,3.373,0,0,0,3.2,3.2"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                  </g>
                </svg>
              </Col>
              <Col lg="6" className="d-lg-flex flex-column justify-content-between">
                <h2 className="mt-3 text-uppercase">Envie de relever un defi professionnel chez synergie ?</h2>
                <p className="mt-3">
                  Bonne idée, car nous faisons tout notre possible pour que les collègues Synergie se sentent bien chez nous, jour
                  après jour.
                </p>
                <p>
                  Que vous travailliez en tant que consultant en agence ou en inhouse, Branch Manager ou dans l'un de nos
                  départements au siège, vous pouvez être vous-même.
                </p>
                <p>
                  Explorez les possibilités sur{' '}
                  <a href="https://www.travaillerchezsynergie.be" target="_blank" rel="noopener noreferrer">
                    travaillerchezsynergie.be
                  </a>{' '}
                  et devenez <strong>happy@synergie</strong>!
                </p>
                <Row className="mt-3">
                  {testimonial && (
                    <Col xl="6" className="mt-2">
                      <a
                        href="https://www.travaillerchezsynergie.be/colleagues/6337094f3b16b0385462bd33/joyce"
                        target="__blank"
                        rel="noopener noreferrer"
                      >
                        <Cta className="cta border-solid small w-100 btn-outline-primary" type="button">
                          Joyce, Consultant, raconte
                        </Cta>
                      </a>
                    </Col>
                  )}
                  <Col xl="6" className="mt-2">
                    <a href="https://www.travaillerchezsynergie.be" target="_blank" rel="noopener noreferrer">
                      <Cta className="cta red small w-100" type="button">
                        Allez vers travailler chez Synergie
                      </Cta>
                    </a>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      )}
    </>
  );
}

export default AboutFr;
